$(document).ready(function() {
    
  // Function to get URL parameters
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };
  
  // Check if cashback parameter is present and find a matching announcement
  var cashbackParam = getUrlParameter('cashback');
  
  if (cashbackParam !== '') {
    $('.sbly--cashback .toolbar__item--announcements').each(function() {
      var announcementCode = $(this).data('cashback-code');
      if (cashbackParam === announcementCode) {
        $('.toolbar.sbly--cashback').show();
        $(this).show(); 
      }
    });
  }
  
  // Close button click event
  $('.sbly--cashback-close').click(function(e) {
    e.preventDefault();
    $('.sbly--cashback').fadeOut();
  });
  
});

